import { createContext, useContext, useState } from "react";
import UpgradeModal from "@/components/UpgradeModal";

const PremiumCtx = createContext({ openUpgrade: () => {} });

export function PremiumProvider({ children }) {
  const [open, setOpen] = useState(false);
  return (
    <PremiumCtx.Provider value={{ openUpgrade: () => setOpen(true) }}>
      {children}
      <UpgradeModal open={open} onClose={() => setOpen(false)} />
    </PremiumCtx.Provider>
  );
}

export const usePremium = () => useContext(PremiumCtx);
